import { screenMaxSizes } from '../../data';

export function getViewportType() {
  const width = window.innerWidth;
  if(width > screenMaxSizes.tablet) {
    return 'desktop';
  }

  if(width > screenMaxSizes.mobile) {
    return 'tablet';
  }

  return 'mobile';
}

export function getViewportSize() {
  return {
    height: window.innerHeight,
    width: window.innerWidth,
  }
}